import { RCE_EVENT, SET_RCE_ERROR, SET_RCE_CONFIG } from '@instructure/quiz-common';
export var setRCEError = function setRCEError(rceError) {
  return {
    type: SET_RCE_ERROR,
    payload: rceError
  };
};
export var setStoredRCEConfig = function setStoredRCEConfig(rceConfig) {
  return {
    type: SET_RCE_CONFIG,
    payload: rceConfig
  };
};

// This is not consumed by its reducer
// Instead it is processed by the eventLoggerMiddleware
export var reportRCEEvent = function reportRCEEvent(eventMessage) {
  return {
    type: RCE_EVENT,
    payload: {
      message: eventMessage
    }
  };
};